<template>
  <div class="back_button row_center_center" @click="back">
    <text class="button-icon row_center_center"
      style="font-size: 26px; color: #000; width: 26px; height: 26px;">arrow_back_ios</text>
    <text class="back_text">返回</text>
  </div>
</template>
<script>
import backIconImage from "../assets/back.png";
export default {
  props: {
    backRoute: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      backIconImage: backIconImage,
    };
  },
  methods: {
    back() {
      if (this.backRoute) {
        return this.$router.push(this.backRoute);
      }
      return this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.back_button {
  position: absolute;
  left: 10px;

  .back_text {
    font-size: 16px;
    font-weight: 400;
    color: #000;
  }
}
</style>
